export const API_URL = "https://api.sweitinfotech.com/v1.0/"
export const HEADERS = {
    'Content-type': 'application/json; charset=UTF-8',
}